import classNames from 'classnames';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, Button } from '@bingads-webui-react/primitive';
import { TooltipHost, DirectionalHint } from '@fluentui/react';
import { withLayoutContext } from '@bingads-webui-react/app-layout-container';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { getToggleMenuItemStyles } from '../styles/toggle-menu-item-styles';

const ToggleMenuItem = ({
  classes, onToggle, i18n, layoutConfig, activity, isMainNavPanelMode,
}) => {
  const isExpandedMode = isMainNavPanelMode || layoutConfig.nav.mode === 'expanded';
  const toggleButtonText = isExpandedMode
    ? i18n.getString(_TL_('Hide navigation menu'))
    : i18n.getString(_TL_('Show navigation menu'));

  const toggleButtonAriaLabel = isExpandedMode
    ? i18n.getString(_TL_('Hide navigation menu'))
    : i18n.getString(_TL_('Show navigation menu'));

  useEffect(() => {
    activity.signal('Hamburger menu rendered');
  }, []);

  return (
    <div className={classNames(classes.toggleMenuItemContainer, 'toggle-menu-item')}>
      <TooltipHost
        id="tooltip-right"
        directionalHint={DirectionalHint.rightCenter}
        delay={300}
        content={toggleButtonText}
      >
        <Button
          className={classNames(classes.toggleButton, 'main-menu-toggle-button')}
          onClick={(...args) => {
            onToggle(...args);
            activity.signal('Hamburger menu clicked');
            setClarityTag({ HamburgerMenuClicked: 'true' });
          }}
          btnStyle="command"
          aria-label={toggleButtonAriaLabel}
        >
          <Glyphicon
            id="toggle-icon"
            className={classes.toggleIcon}
            glyph="ba-GlobalNavButton"
          />
        </Button>
      </TooltipHost>
      <div className={classNames(classes.rightmostDivider, 'toggle-menu-item-divider')} />
    </div>
  );
};

ToggleMenuItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getToggleMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  layoutConfig: PropTypes.shape({
    nav: PropTypes.shape({
      mode: PropTypes.string,
    }),
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }),
  isMainNavPanelMode: PropTypes.bool,
};

ToggleMenuItem.defaultProps = {
  activity: {
    signal: _.noop,
  },
  isMainNavPanelMode: false,
};

export default withLayoutContext(withActivityContext(withDefaultStyles(
  ToggleMenuItem,
  getToggleMenuItemStyles
)));
